@switch (state().status) {
  @case ('loading') {
    <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
  }
  @case ('error') {
    @if (showErrorDisplay) {
      <div class="flex items-center">
        <mat-icon class="w-7 h-7" svgIcon="fi-fehler-20"></mat-icon>
        <div class="mu-heading-2 pl-[0.8rem]">{{ 'delivery-product-details.error_title' | translate }}</div>
      </div>
      <div class="pt-4 pl-[2.8rem]">
        {{ 'delivery-product-details.error_document_viewer' | translate }}
      </div>
    }
  }
  @case ('success') {
    <div [innerHTML]="successContent()" class="parsedDocument"></div>
  }
}
